import Store from "@/App/store";

let pageIsReloading = false;

export function newServiceWorkerActive(serviceWorker: ServiceWorkerContainer) {
  if (!serviceWorker) {
    return;
  }
  serviceWorker.addEventListener("controllerchange", () => {
    if (pageIsReloading) {
      return;
    }
    window.location.reload();
    pageIsReloading = true;
  });
}

export function newServiceWorkerWaiting(registration: ServiceWorkerRegistration) {
  if (!registration.waiting) {
    return;
  }
  Store.dispatch("Error/setError", "New version available. Reloading page...");
  registration.waiting.postMessage({ action: "skipWaiting" });
}

export default {
  newServiceWorkerActive,
  newServiceWorkerWaiting
};
